/* eslint-disable react/prop-types,no-unused-vars */
import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import PreloaderComponent from "../../components/PreloaderComponent/PreloaderComponent";
import "assets/css/style.css";

import jobDetailsPageStyle from "assets/jss/material-kit-pro-react/views/jobDetailsPageStyle.jsx";
import "assets/css/style.css";
import classNames from "classnames";
import SnackbarContent from "components/Snackbar/SnackbarContent.jsx";

import { connect } from "react-redux";
import { jobActions } from "../../actions";
import { orderActions } from "../../actions/order.actions";
import { paymentActions } from "../../actions/payment.actions";
import Priority from "@material-ui/icons/PriorityHigh";
import {toast, ToastContainer} from "react-toastify";
const queryString = require("query-string");

// var paypal = require('paypal-rest-sdk');

// eslint-disable-next-line react/prop-types

class JobContractor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      job: "",
      order: [],
      preloader: false,
      payPalError: false,
      percent: 10,
      payPalErrorMessage: ''
    };
  }

  payJob() {
    this.setState({ preloader: true });
    let quantity = 1;
    let percent = 10;

    let create_order_json = {
      user: this.props.user,
      job: this.state.job,
      price: this.state.job.total * quantity,
      percent: this.state.percent,
      total:
        this.state.job.total + (this.state.job.total * this.state.percent) / 100
    };

    this.props.createOrder(create_order_json).then(
      res => {
        let create_payment_json = {
          name: this.state.job.jobName,
          price: this.state.job.total,
          quantity: quantity,
          total: this.state.job.total * quantity,
          order: res.order
        };

        this.props.createJobPayment(create_payment_json).then(
          res => {
              window.location.href = res.payment.links[1].href;
          },
          err => {
            this.setState({ preloader: false, payPalError: true, payPalErrorMessage: err === "This job has already been paid" ? err : "" });
          }
        );
      },
      err => {
        console.log("55", err);
      }
    );
  }

  componentDidMount() {
    let jobId = this.props.match.params.id;
    this.setState({ preloader: true });

    if (jobId) {
      this.props.getJobById(jobId).then(
        res => {
          this.setState({ preloader: false, job: res.job });
        },
        err => {
          console.log("errrrrr", err.responce);
          this.setState({ preloader: false });
        }
      );
    }
    // console.log(this);
  }

  closeAlerts = () => {
    this.setState({ payPalError: false, payPalErrorMessage: "" });
  };

  render() {
    const { classes, rest } = this.props;

    return (
      <div>
        <div
          className={classNames(
            classes.main + " fix-height-conteiner",
            classes.mainRaised + " m-header" + " content-center"
          )}
        >
          <div
            className={
              classes.container + " " + classes.customerDashboardContainer
            }
          >
            {this.state.payPalError ? (
              <div>
                <SnackbarContent
                  message={
                    <span>
                      {this.state.payPalErrorMessage === "" ? "Paypal connection error. Please try again later." : this.state.payPalErrorMessage}
                    </span>
                  }
                  close
                  color="danger"
                  icon={Priority}
                  closeAlert={this.closeAlerts}
                />
              </div>
            ) : null}
            <GridContainer
              justify="center"
              className={classes.customerNameContainer + " m-cont"}
            >
              <GridContainer>
                <GridItem
                  xs={12}
                  sm={12}
                  md={12}
                  className={classes.customerName}
                >
                  <Card className={"cart-container-job-contractor"}>
                    <CardBody>
                      <h3
                        className={"v-j-variable job-page-title job-pay-title"}
                      >
                        Almost there...
                      </h3>
                      <p className={"v-j-variable text-complete-work"}>
                        Finalise your job by hitting the button below.
                      </p>
                      <hr />
                      <div>
                        <button
                          className="paypal-button"
                          onClick={e => this.payJob()}
                        >
                          <span className="paypal-button-title" />
                          <span className="paypal-logo">
                            <img src="data:image/svg+xml;base64,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" alt="PP" className="paypal-logo paypal-logo-pp paypal-logo-color-blue"></img>
                            <i className={"paypal-logo-first"}>Pay</i>
                            <i className={"paypal-logo-last"}>Pal</i>
                          </span>
                        </button>
                        <p className="paypal-powerd-by">
                          <i className={"paypal-logo-first"}>Powered by </i>
                          <span className="paypal-logo-mini">
                            <i className={"paypal-logo-first"}>Pay</i>
                            <i className={"paypal-logo-last"}>Pal</i>
                          </span>
                        </p>
                        <hr />
                      </div>
                      <div className={"job-pay-details"}>
                        <p className={"v-j-variable "}>Your job details:</p>
                        <p className={"v-j-variable"}>
                          City: {this.state.job.city}
                        </p>
                        <p className={"v-j-variable"}>
                          Address: {this.state.job.address}
                        </p>
                        <p className={"v-j-variable"}>
                          Amount: £{this.state.job.total} 
                        </p>
                        <p className={"v-j-variable"}>
                          Service fee: {this.state.percent}%
                        </p>
                        <p className={"v-j-variable"}>
                          Total Amount:{" "}
                          £{(this.state.job.total + (this.state.job.total * this.state.percent) / 100).toFixed(2)}                         
                        </p>
                      </div>
                    </CardBody>
                  </Card>
                </GridItem>
              </GridContainer>
            </GridContainer>
          </div>
        </div>

        {this.state.preloader && <PreloaderComponent />}
      </div>
    );
  }
}

export default connect(
  store => {
    return {
      user: store.users.user
    };
  },
  {
    getJobById: jobActions.getJobById,
    createOrder: orderActions.createOrder,
    createJobPayment: paymentActions.createJobPayment,
    executePayment: paymentActions.executePayment
  }
)(withStyles(jobDetailsPageStyle)(JobContractor));
